import React from "react";
// import { Link } from "react-router-dom";

function ManagHero({ language = "en" }) {
  return (
    <section className="hero contact-hero">
      <div
        className="hero-slides"
        style={{ backgroundImage: "url(/img/jr5.png)" }}
      />

      <h1>
        {language === "ar"
          ? "خدمات الاستشارات الادارية"
          : "Managment Consulting Services"}
      </h1>

      <div className="hero-texts">
        <div className="hero-text active">
          <p>
            {language === "ar"
              ? "نساعدك على تحسين العمليات، وبناء الاستراتيجيات، وتحقيق نمو قابل للقياس"
              : "We help you improve operations, build strategies, and deliver measurable growth."}
          </p>
        </div>
      </div>

      {/* ✅ الزر يروح لصفحة الدفع */}
   

<a href="#contact" className="btn">
        {language === "ar" ? " أرسل طلباً" : "SEND A REQUEST"}
      </a>

      <div className="slider-dots">
        <div className="dot active" />
      </div>
    </section>
  );
}

export default ManagHero;